import { Provider as AlertProvider, positions, transitions } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import { createRoot } from 'react-dom/client';

import App from './App';
import GlobalStyles from './themes/GlobalStyles';

const options = {
    position: positions.TOP_CENTER,
    timeout: 5000,
    offset: '10rem',
    transition: transitions.FADE,
    type: 'error',
};
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <>
        <GlobalStyles />
        <AlertProvider template={AlertTemplate} {...options}>
            <App />
        </AlertProvider>
    </>
);
